import React from "react";
import styles from "./ui.module.css";

export const Field = ({
  label,
  htmlFor,
  error,
  className = "",
  children,
}) => {
  return (
    <div className={`${styles.field} ${className}`}>
      {label && (
        <label className={styles.label} htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {children}
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};
